import React, {useEffect, useState} from 'react';
import { format } from 'date-fns';
import { getJsLocale } from 'js/utilities';

const locale = getJsLocale();

export default function ConversionComponentQuickDate({numberOfDays = 0, updateValue, dateBackendFormat, value}) {
    const loopArray = Array(numberOfDays).fill();
    const [range, setRange] = useState([]);

    useEffect(() => {
        if (!range.includes(value) && value) {
            fillRangeWithDays(value)
        }
    }, [value]);

    useEffect(() => {
        let startDateToUse;
        if (value) {
            startDateToUse = value;
        } else {
            startDateToUse = new Date();
            startDateToUse = new Date(startDateToUse.setDate(startDateToUse.getDate() + 1));
        }
        fillRangeWithDays(startDateToUse);
    }, [numberOfDays]);

    function fillRangeWithDays(startDate) {
        let rangeTemp = []
        let hasSunday = false;
        loopArray.forEach((day, dayIndex) => {
            let loopDay = startDate ? new Date(startDate) : new Date();

            // Voegt bij elke iteratie een dag toe + een extra dag als er een zondag is geweest.
            if (!hasSunday) {
                loopDay = dayIndex > 0 ? new Date(loopDay.setDate(loopDay.getDate() + dayIndex)) : loopDay;
            } else {
                loopDay = dayIndex > 0 ? new Date(loopDay.setDate(loopDay.getDate() + dayIndex + 1)) : loopDay;
            }

            // Extra iteratie op zondag
            if (loopDay.getDay() === 0) {
                hasSunday = true;
                loopDay = new Date(loopDay.setDate(loopDay.getDate() + 1))
            }

            loopDay = format(loopDay, dateBackendFormat)

            rangeTemp.push(loopDay)
            setRange(rangeTemp);
        })
    }

    return (
        <>
            {range.length > 0 ?
                <div className="d-flex flex-wrap gap-2 gap-xl-4 quick-date">
                    {range.map((day, dayIndex) => {
                        const dayDate = new Date(day);
                        const selected = `${dayDate.getFullYear()}-${('0' + (dayDate.getMonth()+1)).slice(-2)}-${('0' + (dayDate.getDate())).slice(-2)}` === value;

                        return (
                            <button
                                key={dayIndex}
                                className={`d-flex flex-column gap-2 justify-content-center align-items-center quick-date__day${selected ? ' quick-date__day--active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    updateValue(format(dayDate, dateBackendFormat));
                                }}
                            >
                                <span className="quick-date__day-text text-sm">{dayDate.toLocaleString(locale, { weekday: 'short' })}</span>
                                <span className="quick-date__day-date d-flex flex-column justify-content-center">
                                    <span className="text-xs fw-bold">{dayDate.getDate()}</span>
                                    <span className="text-xs">{dayDate.toLocaleString(locale, { month: 'short' })}</span>
                                </span>
                            </button>
                        )
                    })}
                </div>
            : null}
        </>
    )
}
